import { Head, Link } from '@inertiajs/react'
import type { ReactNode } from 'react'
import Layout from '@/layouts/Layout'

export default function Terms() {
  return (
    <>
      <Head title="Terms of Service" />
      <div className="container mx-auto px-4 py-8 max-w-3xl">
        <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>

        <div className="prose">
          <p className="mb-4">
            Welcome to three.pm. By using our service, you agree to these terms.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">1. Service Description</h2>
          <p className="mb-4">
            three.pm is a photo sharing service that allows you to share one moment per day with
            people you follow. The service operates primarily via SMS/iMessage.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">2. Account Creation</h2>
          <p className="mb-4">
            To use three.pm, you must create an account by messaging our service. You agree to
            provide accurate information and maintain the security of your account.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">3. Content Guidelines</h2>
          <p className="mb-4">
            You retain ownership of content you post. By posting, you grant us a license to display
            and distribute your content to your followers. Do not post illegal, harmful, or
            offensive content.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">4. Privacy</h2>
          <p className="mb-4">
            Your privacy matters to us. Please see our{' '}
            <Link href="/privacy" className="text-blue-600 hover:underline">
              Privacy Policy
            </Link>{' '}
            for details on how we collect, use, and protect your information.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">5. Termination</h2>
          <p className="mb-4">
            We may terminate or suspend your account at any time for violations of these terms.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">6. Changes to Terms</h2>
          <p className="mb-4">
            We may update these terms from time to time. Continued use of the service constitutes
            acceptance of updated terms.
          </p>
        </div>
      </div>
    </>
  )
}

Terms.layout = (page: ReactNode) => <Layout>{page}</Layout>
